export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const MONTH_FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const nf = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 });

export function money(n, currency = '₹') {
  const v = Number(n) || 0;
  return (v < 0 ? '-' : '') + currency + nf.format(Math.abs(v));
}

export const num = (n) => nf.format(Number(n) || 0);
export const pct = (n) => (n == null ? '—' : `${(Number(n)).toFixed(2)}%`);

export function today() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function fmtDate(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-');
  if (!d) return iso;
  return `${d} ${MONTHS[Number(m) - 1] || ''} ${y}`;
}

export function fmtDDMMYYYY(dateStr) {
  if (!dateStr) return '-';
  const parts = String(dateStr).split('T')[0].split('-');
  if (parts.length === 3) {
    const [y, m, d] = parts;
    if (y.length === 4) return `${d.padStart(2, '0')}-${m.padStart(2, '0')}-${y}`;
  }
  return dateStr;
}

export function monthRange(year, month /* 1-12 */) {
  const last = new Date(year, month, 0).getDate();
  const mm = String(month).padStart(2, '0');
  return { from: `${year}-${mm}-01`, to: `${year}-${mm}-${String(last).padStart(2, '0')}` };
}
